const orderList = {
  state: { relateInfoId: '', visible: false },
  mutations: {
    SET_RELATE_INFO: (state, data) => {
      state.relateInfoId = data
    },
    SET_VISIBLE: (state, data) => {
      state.visible = data
    }
  },
  actions: {}
}

export default orderList
